import { atom } from "recoil";

const mealDetailsPopUpAtom = atom({
  key: "mealDetailsPopUp",
  default: {
    isTriggered: false,
    mealData: null,
  },
});

export default mealDetailsPopUpAtom;
